import * as React from "react";
const SvgArrowIndicatorUp = (props) => /* @__PURE__ */ React.createElement("svg", { width: 6, height: 3, viewBox: "0 0 6 3", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M3 0L5.59808 3H0.401924L3 0Z", fill: "currentColor" }));
export default SvgArrowIndicatorUp;
